import { Link } from "react-router-dom";
import { MapPin, Phone, EnvelopeSimple, Clock } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="bg-[#1A2421] text-brand-bone mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Logo Section - Updated with your logo */}
        <div>
          <Link to="/" className="flex items-center gap-3 mb-5">
            <img 
              src="/logo.png" 
              alt="Aravali Care Hospital" 
              className="h-12 w-auto object-contain brightness-0 invert" 
            />
            <div className="leading-tight">
              <div className="font-serif text-xl">JASHODA HOSPITAL</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-brand-bone/60">Multi‑Specialty Healthcare</div>
            </div>
          </Link>
          <p className="text-sm text-brand-bone/70 leading-relaxed">
            Compassionate healthcare rooted in science, delivered with warmth. Serving families across the region since 1998.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-5">Explore</h4>
          <ul className="space-y-3 text-sm text-brand-bone/70">
            <li><Link to="/services" className="hover:text-brand-bone">Services</Link></li>
            <li><Link to="/doctors" className="hover:text-brand-bone">Our Doctors</Link></li>
            <li><Link to="/book" className="hover:text-brand-bone">Book Appointment</Link></li>
            <li><Link to="/blog" className="hover:text-brand-bone">Health Journal</Link></li>
            <li><Link to="/about" className="hover:text-brand-bone">About Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-5">Contact</h4>
          <ul className="space-y-3 text-sm text-brand-bone/70">
            <li className="flex gap-3"><MapPin size={18} className="mt-0.5 shrink-0" /> Jaluki Stand, Deeg (Rajasthan) 321205</li>
            <li className="flex gap-3"><Phone size={18} className="mt-0.5 shrink-0" /> +91 9462-02-0447</li>
            <li className="flex gap-3"><EnvelopeSimple size={18} className="mt-0.5 shrink-0" />care@aravalicare.in</li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-5">Hours</h4>
          <ul className="space-y-3 text-sm text-brand-bone/70">
            <li className="flex gap-3"><Clock size={18} className="mt-0.5 shrink-0" /> OPD: Mon–Sat, 8:00–20:00</li>
            <li className="flex gap-3"><Clock size={18} className="mt-0.5 shrink-0" /> Sunday: 10:00 am – 08:00 pm</li>
            <li className="text-[#C85A40] font-medium">Emergency: 24 / 7 / 365</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-brand-bone/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-brand-bone/50">
          <div>© {new Date().getFullYear()} JASHODA HOSPITAL. All rights reserved.</div>
          <div className="flex gap-6">
            <span>Privacy Policy</span>
            <span>Terms of Care</span>
            <span>Accreditations</span>
          </div>
        </div>
        
        {/* Developed by Section */}
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-6 text-center text-xs text-brand-bone/40">
          Designed & Developed by{' '}
          <a 
            href="https://kasinfotech.in" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-brand-bone/60 hover:text-brand-bone transition-colors hover:underline"
          >
            KAS INFO TECH
          </a>
        </div>
      </div>
    </footer>
  );
}